<template>
    <div class="body">
        <div class="btn" @click="isDialogShow=true"></div>
        <!--显示活动弹窗-->
        <div class="v-dialog" v-if="isDialogShow">
            <div class="v-dialog-bg"></div>
            <div class="v-dialog-content">
                <div class="input">{{input}}</div>
                <div class="sumbit_btn" @click="sureToRecharge()"></div>
                <div class="v-dialog-close">
                    <img src="@/assets/dzp/dialog_close.png" alt="" @click="isDialogShow=false" />
                </div>
            </div>
        </div>
        <!-- 修改密码框   -->
        <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
        <div class="van-popup van-popup--round van-popup--center changePasswordPanel-cardSetUp"
            style="z-index: 2000; min-height: 25%; min-width: 80%;"
            v-show="showPasswordPanel"
            :style="{top:passwordPanelTop+'%'}"
        >

        <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()"/>

        <!-- 密码输入框 -->
        <p>设置开户支付密码：</p>
        <van-password-input
            :value="password"
            :focused="passwordKeyboard"
            @focus="passwordOnfocus()"
        />

        <!-- 再次确认密码输入框 -->
        <p>再次确认开户密码：</p>
        <van-password-input
            :value="confirmPassword"
            :focused="confirmPasswordKeyboard"
            @focus="confirmPasswordOnfocus()"
        />
        <div class="confirmChangePassword">
            <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToRecharge()">确 定
            </van-button>
        </div>

        </div>

        <!-- 数字键盘 -->
        <van-number-keyboard
            :z-index="2015"
            :show="passwordKeyboard"

            @input="passwordOnInput"
            @delete="passwordOnDelete"
            @blur="passwordKeyboard = false"
        />

        <van-number-keyboard
            :z-index="2015"
            :show="confirmPasswordKeyboard"

            @input="confirmPasswordOnInput"
            @delete="confirmPasswordOnDelete"
            @blur="confirmPasswordKeyboard = false"
        />
        <!-- 数字键盘 end -->
        <!-- 修改密码框 end  -->
    </div>
</template>
<script>
import {Dialog,Toast} from 'vant';
import {wxRequest} from '@/api/user.js'
export default {
    data(){
        return{
             newHome:this.$store.state.newHome,
            newHomes: localStorage.getItem("newHome"),
            input:this.$store.state.recordLoginText,
            isDialogShow:false,
            //设置密码
            password: '',
            confirmPassword: "",
            alreadySetUp: false,
            showPasswordPanel: false,
            passwordKeyboard: false,
            confirmPasswordKeyboard: false,
            passwordPanelTop: 50,


            //当前余额套餐
            currentItem: 0,
            price: 0,
            giftBalance: 0,

            //自定义金额
            popup: false,

            //自定义键盘
            showKeyboard: false,
            definedPrice: '',

            type: '',
            indexActive: '',
        }
    },
    methods:{
        /***   修改密码     ***/
        passwordOnfocus() {
            this.passwordKeyboard = true;
            this.confirmPasswordKeyboard = false;
            this.passwordPanelTop = 30;
        },
        passwordOnDelete() {
            this.password = this.password.slice(0, this.password.length - 1);
        },

        passwordOnInput(key) {
            this.password = (this.password + key).slice(0, 6);
        },


        confirmPasswordOnfocus() {
            this.passwordKeyboard = false;
            this.confirmPasswordKeyboard = true;
            this.passwordPanelTop = 30;
        },
        confirmPasswordOnDelete() {
            this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
        },

        confirmPasswordOnInput(key) {
            this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
        },


        cancelChangePassword() {
            this.password = '';
            this.confirmPassword = '';
            this.passwordPanelTop = 50;
            this.showPasswordPanel = false;
        },

        checkPassword() {
            if (this.password.length < 6) {
                Dialog.alert({message: "请设置六位支付密码"});
                return false;
            }

            if (this.password != this.confirmPassword) {
                Dialog.alert({message: "两次输入的新密码不一致"});
                return false;
            }
            return true;
        },


        /***   修改密码  end   ***/
        sumbit(){
            this.showPasswordPanel = true;
        },
           //流量套餐充值时唤起微信支付
         onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest', param,
                function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        if(this.newHome==1||this.newHomes==1){
                                 _this.$router.push({
                        path: '/newUser/home',
                        query: {
                        iccid: _this.$store.state.iccid
                        }
                    }).catch(() => {

                    });
                        }else{
                             _this.$router.push({
                        path: '/user/home',
                        query: {
                        iccid: _this.$store.state.iccid
                        }
                    }).catch(() => {

                    });
                        }
                    }
                }
            );
        },
        sureToRecharge(){
            var params = {         
                iccid:this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem('iccid'), 
                amount: 60 * 100, //固定值         
                giftBalance: 0, //固定值 	   
                yucun: 1, //固定值
                payType: 20,// 固定微信支付         
                         
            }
            wxRequest("order/user/create/priceOrder", params, "post").then(res => {
                if (res.data.code == 200) {
                    if (params.payType == 50) {//乐刷
                        window.location.href = res.data.data.jspay_url;
                    } else if (params.payType == 20) {//微信第三方
                            var param = res.data.data.param;
                            if (typeof WeixinJSBridge == "undefined") {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                                }
                            } else {
                                this.onBridgeReady(param);
                            }
                       
                    } else if (params == 60) { //汇付天下
                        let datas = JSON.parse(res.data.data);
                        if (datas.status === 'succeeded') {
                            let payment = datas;
                            AdaPay.doPay(payment, (res) => {
                                Dialog.alert({title: '提示', message: res.result_message});
                            })
                        }
                    }
                } else {
                    Dialog.alert({message: res.data.message});
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.body{
    background: url('../../assets/dzp/le.jpg')no-repeat center;
    background-size: 100% 100%;
    width:100%;
    height:100vh;
    position: relative;
    .btn{
        width: 325px;
        position: fixed;
        bottom: 20px;
        left: 0px;
        right: 0px;
        margin: auto;
        height: 64px;
        background: url('../../assets/dzp/6fdec6ce.png')no-repeat center;
        background-size: 100% 100%;
    }
    .v-dialog{
        position:absolute;
        width:100%;
        height:100%;
        top:0;
        bottom: 0;
        left:0;
        right:0;
        margin:auto;
        .v-dialog-bg{
            position: fixed;
            background: rgba(0,0,0, .7);
            top:0;
            bottom: 0;
            left:0;
            right:0;
            margin:auto;
            width:100%;
            height:100%;
        }
        .v-dialog-close{
            width:22px;
            height:22px;
            // margin:0 auto;
            // margin-top:20px;
            position: fixed;
            top:0;
            bottom:-300px;
            left:0;
            right:0;
            margin:auto;
            img{
                height:100%;
                cursor: pointer;
            }
        }
        .v-dialog-content{
            position: fixed;
            top:0;
            bottom: 0;
            left:0;
            right:0;
            margin:auto;
            width: 275px;
            height: 210px;
            background: url('../../assets/dzp/t_c.png') no-repeat center;
            background-size:100% 100%;
            .input{
                background: rgb(255, 255, 255);
                width: 200px;
                height: 40px;
                margin: auto;
                margin-bottom: 10px;
                border-radius: 12px;
                text-align: center;
                line-height: 40px;
                font-size: 25px;
                color: rgb(177, 54, 0);
                position: absolute;
                bottom:54px;
                display: flex;
                left:0;
                right:0;
                justify-content: center;
                align-items: center;
            }
            .sumbit_btn{
                width: 175px;
                height: 46px;
                position: absolute;
                bottom:8px;
                display: flex;
                left:0;
                margin: auto;
                right:0;
                background: url('../../assets/dzp/a2.png') no-repeat center;
                background-size:100% 100%;
            }
        }
    }
}
.changePasswordPanel-cardSetUp{
	  padding: 10px;

	  .icon-cross{
	  	position: absolute; 
	  	right: 10px;
	  	font-size: 16px;
	  }

	  p{
	    margin: 10px 16px 0 16px;
	    line-height: 30px;
	  }

	  .confirmChangePassword{
	    display:flex;
	    justify-content: flex-end;
	    margin-top: 20px;

	    .confirmChangePasswordBtn{
	    	width: 80px;
	      	margin: 0 15px;
	    }
	  }


	}
</style>